import { Link } from 'expo-router';
import React from 'react';

import { Text, createMqStyles, tokens } from '@fhs/ui';

export const DeliveryTermsNotice: React.VFC = () => {
  const styles = useDeliveryTermsNoticeMqStyles();

  return (
    <Text.Paragraph size="xs" style={styles.notice} testID="store-locator-delivery-terms-notice">
      {'Delivery terms and fees apply. '}
      <Link
        href="/delivery-terms"
        style={styles.link}
        accessibilityLabel="View details about delivery terms and fees"
        testID="store-locator-delivery-terms-link"
      >
        View details
      </Link>
      .
    </Text.Paragraph>
  );
};

const useDeliveryTermsNoticeMqStyles = createMqStyles({
  notice: {
    $base: {
      color: tokens.colors.$blackOpacity75,
      lineHeight: 14,
      textAlign: 'center',
    },
    $gteDesktop: {
      lineHeight: 17,
    },
  },
  link: {
    $base: {
      color: tokens.colors.$houseRed,
      textDecorationLine: 'underline',
    },
  },
});
